<template>
  <div class="tips-wrapp" draggable="false">
    <transition name="fade">
      <div v-if="isShow" class="mask"></div>
    </transition>
    <transition name="scale">
      <div v-if="isShow" class="bady" :style="{'transform-origin':compCenter}">
        <div class="flex flex-direction">
          <div class="head flex justify-between align-center">
            <div class="title">{{title}}</div>
            <div class="close" @click="hide">
              <i class="icon-cross"></i>
            </div>
          </div>
          <div class="cont flex-sub flex">
            <!-- 修改需求 -->
            <div class="marke" v-if="type=='remark'">
              <div class="textarea">
                <textarea v-model="mainData" maxlength="80"></textarea>
                <div class="text-count">{{mainData.length}}/80</div>
              </div>
              <div class="flex justify-between" style="margin-top:30px">
                <button @click="hide">取消</button>
                <button @click="confirm" class="green">保存</button>
              </div>
            </div>
            <!-- 支付 -->
            <div v-else-if="type=='pay'" class="flex flex-sub flex-direction justify-center">
              <div class="flex zhifu justify-center">
                <div id="qrCode" ref="qrCodeDiv"></div>
              </div>

              <div
                class="flex zhifu2 flex-direction justify-center align-center"
                
              >
                <img class="storeImg" :src="mainData.headUrl" alt />
                <div class="text-18">{{mainData.name}}</div>
                <div class="text-20">
                  支付金额：
                  <span class="text-28" style="color:#D33114">￥{{mainData.price}}</span>
                </div>
              </div>
            </div>
            <!-- 富文本 -->
            <div v-else-if="type=='text'" class="flex-sub">
              <div class="my-scrollbar rich-wrapp" v-html="mainData"></div>
            </div>
            <!-- 提示 -->
            <div
              v-else-if="type=='success'||type=='err'||type=='stop'"
              class="flex flex-sub flex-direction justify-center tishi"
            >
              <div class="flex-sub flex-direction flex justify-center align-center">
                <img class="saveimg" v-if="type=='success'" src="../../assets/img/success.png" />
                <img class="saveimg" v-else-if="type=='stop'" src="../../assets/img/stop.png" />
                <img class="saveimg errimg" v-else-if="type=='err'" src="../../assets/img/err.png" />
                <div class="text-center html-data" style v-html="mainData"></div>
              </div>
              <div class="flex justify-center">
                <button @click="confirm" class="green" v-if="btns.length>0">{{btns[0]}}</button>
              </div>
            </div>
            <!-- 其他选择提示 -->
            <div v-else class="savePhoto flex-sub flex flex-direction">
              <div class="flex-sub">
                <img class="saveimg" src="../../assets/img/save-icon.png" alt srcset />
                <div class="tishi" v-html="mainData"></div>
              </div>
              <div class="flex justify-between">
                <button @click="cancelF" v-if="btns.length==2">{{btns[1]}}</button>
                <button @click="confirm" class="green" v-if="btns.length>0">{{btns[0]}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "Tips",
  data() {
    return {
      type: "remark",
      isShow: false,
      success: null,
      cancel: null,
      title: "",
      transCenter: ["0.5", "0.5"],
      mainData: null,
      btns: []
    };
  },
  methods: {
    show(props, e) {
      let _this = this;
      if (e) {
        let clientWidth = document.body.clientWidth;
        let clientHeight = document.body.clientHeight;
        let screenX = e.screenX;
        let screenY = e.screenY;
        this.transCenter = [screenX / clientWidth, screenY / clientHeight];
      }

      this.type = props.type;

      this.mainData = props.data;

      if (props.btns) {
        this.btns = props.btns;
      }
      this.title = props.title;
      this.isShow = true;
      this.success = props.success || function(){};
      this.cancel = props.cancel || function(){};
      this.close = props.close || function(){};
      this.stopScroll();
    },
    hide() {
      this.isShow = false;
      this.canScroll();
      this.close ? this.close() : "";
    },
    confirm() {
      if (this.type == "remark") {
        this.success(this.mainData);
      } else {
        this.success();
      }
      this.hide();
    },
    cancelF() {
      if (this.cancel) this.cancel();
      this.hide();
    },
    //禁止滚动
    stopScroll() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    }
  },
  computed: {
    compCenter() {
      let center = this.transCenter;
      let a, b;
      if (center[0] <= 0.3) {
        a = "0";
      } else if (center[0] > 0.3 && center[0] <= 0.5) {
        a = "50%";
      } else {
        a = "100%";
      }
      if (center[1] <= 0.3) {
        b = "0";
      } else if (center[1] > 0.3 && center[1] <= 0.4) {
        b = "50%";
      } else {
        b = "100%";
      }
      return a + " " + b + " 0";
    }
  },
  mounted() {
    this.$nextTick(() => {
      let _this = this;
      setTimeout(() => {
        if (this.type == "pay") {
          // 创建二维码
          new QRCode(_this.$refs.qrCodeDiv, {
            text: _this.mainData.payQrcode,
            width: 200,
            height: 200,
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });
        }
      }, 100);
    });
  }
};
</script>

<style lang='scss' scoped>
.tips-wrapp {
  position: fixed;
  z-index: 100;
  font-family: Source Han Sans CN;
  .mask {
    position: fixed;
    width: 100vw;
    height: 100vh;
    min-width: 1000px;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
  }
  .bady {
    transform-origin: 50% 100% 0;
    position: fixed;
    top: 50%;
    left: 50%;
    background-color: #fff;
    z-index: 2;
    margin-left: -205px;
    margin-top: -230px;
    width: 410px;
    min-height: 326px;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    .head {
      width: 100%;
      height: 60px;
      background: rgba(43, 51, 62, 1);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      color: #fff;
      .title {
        padding-left: 28px;
        font-size: 18px;;
      }
      .close {
        padding: 20px;
        cursor: pointer;
        font-size: 10px;
        opacity: 0.4;
      }
    }
    .cont {
      .rich-wrapp {
        padding: 30px;
        overflow: auto;
        max-height: 400px;
        line-height: 1.5;
      }
      .tishi {
        padding: 30px 0;
        line-height: 1.5;
      }
      .zhifu {
        padding: 20px 0 40px 0;
        border-bottom: 1px solid #efefef;
      }
      .zhifu2{
        padding-bottom: 20px;
        margin-top: -25px;
        line-height: 1.5;
      }
      .html-data {
        line-height: 1.5;
        padding: 25px 0;
      }
      .errimg {
        width: 100px;
        height: 100px;
      }
      .marke {
        padding: 30px;
        .textarea {
          height: 140px;
          background: rgba(248, 250, 252, 1);
          border: 1px solid rgba(231, 233, 237, 1);
          border-radius: 4px;
          textarea {
            border: 0;
            background: none;
            resize: none;
            padding: 13px 15px;
            width: 320px;
            height: 90px;
            color: #333c48;
            font-size: 14px;
            line-height: 1.5;
            padding-bottom: 0;
          }
          .text-count {
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 19px;
            text-align: right;
            padding: 0 15px;
          }
        }
      }
      .savePhoto {
        padding: 20px 20px 30px;
        text-align: center;
        color: #333c48;
        line-height: 1.5;
        .saveimg {
          width: 60px;
          height: 50px;
        }
      }
      button {
        width: 171px;
        height: 36px;
        background: linear-gradient(
          180deg,
          rgba(241, 243, 247, 1),
          rgba(255, 255, 255, 1)
        );
        border: 1px solid rgba(206, 208, 218, 1);
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        cursor: pointer;
      }
      .green {
        background: linear-gradient(
          0deg,
          rgba(57, 181, 74, 1),
          rgba(51, 170, 68, 1)
        );
        border: 1px solid rgba(36, 149, 51, 1);
        color: rgba(255, 255, 255, 1);
      }
      .storeImg {
        width: 50px;
        height: 50px;
        background: #1166a5;
        border-radius: 50%;
        margin-bottom: 12px;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.scale-enter-active,
.scale-leave-active {
  transition: all 0.1s;
}
.scale-enter, .scale-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: scale(0.5);
}
</style>